export default "__VITE_ASSET__ZQJAjWhz__"